import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { addUtils } from './class-name-helpers';

function createListProps({ className, ...props }, baseClass) {
  const { restProps, utilClassNames } = addUtils(props);

  return {
    className: clsx(className, baseClass, utilClassNames),
    ...restProps,
  };
}

export function UnorderedList(props) {
  return <ul {...createListProps(props, 'ss_list')} />;
}

UnorderedList.defaultProps = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
UnorderedList.defaultProps = {
  className: '',
};

export function ListItem(props) {
  return <li {...createListProps(props, 'ss_list__item')} />;
}

ListItem.defaultProps = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
ListItem.defaultProps = {
  className: '',
};
